import { uniqBy } from 'lodash';
import { APIScopeData, ArdoqId, APIScopeDataCore } from '@ardoq/api-types';
import {
  Branch,
  EnhancedScopeData,
  type EnhancedScopeDataWithBranchName,
} from '@ardoq/data-model';
import * as scopeDataPackage from '@ardoq/scope-data';

export type { EnhancedScopeDataWithBranchName } from '@ardoq/data-model';

const { scopeDataOperations } = scopeDataPackage;

export const toModelTypes = scopeDataPackage.toModelTypes;
export const toModelTypeDictionary = scopeDataPackage.toModelTypeDictionary;
export const generateHierarchy = scopeDataPackage.generateHierarchy;

export const enhanceScopeDataWithBranchName = (
  enhancedScopeData: EnhancedScopeData,
  branchName: Branch
): EnhancedScopeDataWithBranchName => ({
  branchName,
  ...enhancedScopeData,
});

/**
 * @deprecated Default missing properties before enhancing the scope data or
 * find another way to perform this.
 */
export const enhancePartialScopeData = (scopeData: APIScopeDataCore) => {
  return enhanceScopeDataWithBranchName(
    enhanceScopeData({
      ...scopeDataOperations.getEmpty(),
      ...scopeData,
    }),
    Branch.MAIN
  );
};

export const enhanceScopeData = scopeDataOperations.enhance;

export const getModelTypeDictionaryKey = (model: ArdoqId, typeId: string) =>
  `${model}-${typeId}`;

export const getWorkspacesFromMainlineAndBranch = (
  mainline: APIScopeData,
  branch: APIScopeData
) =>
  // `branchOff` has no workspaces, they are not branched, so we can take them
  // from `mainline` and `branch`.
  uniqBy([...mainline.workspaces, ...branch.workspaces], '_id');
